import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { FileCardRemote } from "@/components/files";
import { useSuborderFiles } from "@/hooks/use-suborder-files";

/** Props Interface */
interface SuborderShippingLabelsProps {
	suborderId: string;
}

/**
 * The shipping labels a picking round produced — one PDF per sign-off that booked load carriers,
 * one label page per physical carrier inside it. The cards download only: a label is the record of
 * what left the yard, so nothing here removes or replaces one.
 */
export function SuborderShippingLabels({ suborderId }: SuborderShippingLabelsProps) {
	/** Context */
	const { t } = useTranslation();

	/** Query */
	const { files } = useSuborderFiles(suborderId);

	/** Render */
	return (
		<ContentCard
			title={t("stock.shipping_labels")}
			icon={icon("Tag")}
			variant="plain"
		>
			{files.length === 0 ? (
				<BlankSlate
					label={t("stock.no_shipping_labels")}
					withAccessory={false}
				/>
			) : (
				<div className="flex flex-col gap-2">
					{files.map((file) => (
						<FileCardRemote
							key={file.id}
							fileId={file.id}
							onInteraction={null}
							withRemove={false}
							variant="content-card"
						/>
					))}
				</div>
			)}
		</ContentCard>
	);
}
